import { environment } from "../../config";

async function bifurcateCosts(apiUrl, apiKey, inputData) {
  console.log('bifurcateCosts inputData : ', inputData)
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({
      //   api_key: apiKey,
      //   input_data: inputData,
      // }),
      body: JSON.stringify(inputData),
      // body: JSON.stringify({
      //   description: "Brick masonry wall using cement mortar with proper curing and leveling",
      //   quantity: 10,
      //   rate: 450,
      //   unit: "sqm",
      //   firm_id: "firm_123",
      // }),
    });

    console.log('bifurcate_costs response : ', response);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Request failed");
    }
    const result = await response.json();
    console.log('bifurcate_costs result : ', result)
    return result;
  } catch (error) {
    console.error("Error calling bifurcate_costs endpoint:", error);
    throw error;
  }
}

function generateStructuredData(materials, workItems) {
    const getRandomId = () => Date.now() + Math.floor(Math.random() * 10000);
    const getRandomStatus = () => {
      const statuses = ["Pending", "In Progress", "Delivered", "Scheduled"];
      return statuses[Math.floor(Math.random() * statuses.length)];
    };
    
    const getRandomOrderStatus = () => {
      const statuses = ["Ordered", "Partially Delivered", "Delivered", "In Review", "Approved"];
      return statuses[Math.floor(Math.random() * statuses.length)];
    };

    const getRandomType = (category) => {
      if (category.toLowerCase().includes("panel")) return "Panel";
      if (category.toLowerCase().includes("frame")) return "Frame";
      if (category.toLowerCase().includes("screw") || category.toLowerCase().includes("fastener")) return "Accessories";
      if (category.toLowerCase().includes("beading")) return "Beading";
      return "General";
    };
  
    const structuredMaterials = materials.map((item) => ({
      OrderId: getRandomId(),
      category: 'Carpenter',
      type: item.type,
      // type: getRandomType(item.category),
      item: ``,
      // item: `${item.category} Item`,
      specification: item.specification,
      quantity: item.Qnt.toString(),
      rate: item.rate.toString(),
      unit: item.unit,
      gst: item.GST.toString(),
      milestones: [
        { name: "Completion", percentage: "100" }
      ],
      status: getRandomStatus(),
      orderStatus: getRandomOrderStatus(),
      itemId: getRandomId()
    }));
  
    const structuredWork = workItems.map((work) => ({
      OrderId: getRandomId(),
      workType: "Only Work",
      vendorCategory: work.categoryxs || "General",
      heading: `${work.categoryxs} Execution`,
      description: work.Description,
      quantity: work.Qnt.toString(),
      rate: work.rate.toString(),
      unit: work.unit,
      gst: work.GST.toString(),
      milestones: [
        { name: "Completion", percentage: "100" }
      ],
      tc: "Work must be completed within 5 working days post material delivery.",
      status: getRandomStatus(),
      orderStatus: getRandomOrderStatus()
    }));
  
    return {
      Material: structuredMaterials,
      Work: structuredWork,
      Remarks: "Ensure material matches approved design before installation.",
      description: "ENTRANCE CEILING \nProviding and Fixing of PVC Ceiling with GI Frame as per the approved shade of design",
      quantity: 80,
      rate: 240,
      unit: "Sft"
    };
  }


const fetchGeneratMaterials = async (componentDescription) => {
  // Example usage
  // earlier URL
  // const apiUrl = "https://us-central1-charming-shield-300804.cloudfunctions.net/componentItemGenerationStg"; // earlier api
  // cuurent URL
  console.log('componentDescription : ', componentDescription);
  const apiUrl = "https://us-central1-charming-shield-300804.cloudfunctions.net/addvendorcomponentstg/bifurcate"; // new api
  const apiKey = "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"; // Replace with your OpenRouter API key
  componentDescription['firm_id'] = "9800270888"; // temporary actual firm id to store the user haviour for changing the generated items
  console.log('componentDescription : ', componentDescription);
  // let fetchedData = await bifurcateCosts(apiUrl, apiKey, [componentDescription]);
  let fetchedData = await bifurcateCosts(apiUrl, apiKey, componentDescription);
  console.log('ComponentCostDetails fetchedData : ', fetchedData);
  let updatedData = await generateStructuredData(fetchedData.material, fetchedData.work);
  // let updatedData = await generateStructuredData(fetchedData.result.material, fetchedData.result.work);

  return {
    work : updatedData.Work,
    material : updatedData.Material
  };
};

export default fetchGeneratMaterials;

